import script from "./shortEventList.vue?vue&type=script&lang=js"
export * from "./shortEventList.vue?vue&type=script&lang=js"

import "./shortEventList.vue?vue&type=style&index=0&id=48bea130&lang=scss"

const __exports__ = script;

export default __exports__